import React, {Component} from 'react';
import _ from 'lodash';
import Loading from "../../loading";

class MunsModal extends Component {
	render() {
		let {conclusion, isMod, muns} = this.props;
		let municipalities = _.filter(muns.list, {modality_id: 3});
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione los municipios participantes</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.muns.isFetching ? <Loading message="Cargando municipios..."/> :
								<div className="field is-grouped is-grouped-multiline">
									{_.toInteger(isMod) === 3 ?
										_.map(municipalities, (mun, k) => {
											let shouldCheck = _.findKey(this.props.selectedMuns, {id: mun.id}) !== undefined ? true : false;
											return (
												<div className="control" key={k}>
													<label htmlFor={`mun-${mun.id}`} className="checkbox"
													       disabled={conclusion}>
														<input id={`mun-${mun.id}`} ref={`g-mun-${mun.id}`}
														       value={mun.id} type="checkbox" checked={shouldCheck}
														       className="checkbox"
														       onChange={() => this._saveMuns(mun.id)}
														       disabled={conclusion}/>
														{mun.name}
													</label>
												</div>
											);
										})
										: _.map(this.props.muns.list,(mun, k) => {
											let shouldCheck = _.findKey(this.props.selectedMuns, {id: mun.id}) !== undefined ? true : false;
											return (
												<div className="control" key={k}>
													<label htmlFor={`mun-${mun.id}`} className="checkbox"
													       disabled={conclusion}>
														<input id={`mun-${mun.id}`} ref={`g-mun-${mun.id}`}
														       value={mun.id} type="checkbox" checked={shouldCheck}
														       className="checkbox"
														       onChange={() => this._saveMuns(mun.id)}
														       disabled={conclusion}/>
														{mun.name}
													</label>
												</div>
											);
										})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveMuns(mun) {
		let munKey = _.findKey(this.props.selectedMuns, {id: mun});
		if (this.refs[`g-mun-${mun}`].checked) {
			this.props.add(`projects.edit.municipalities`, {id: mun});
		} else {
			this.props.remove(`projects.edit.municipalities`, munKey);
		}
	}
}

/*class MunsModal2 extends Component {
	render() {
		let {conclusion, isMod, muns} = this.props;
		let municipalities = _.filter(muns.list, {modality_id: 3});
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background"/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione los municipios participantes</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.muns.isFetching ? <Loading message="Cargando municipios..."/> :
								<div className="field is-grouped is-grouped-multiline">
									{_.toInteger(isMod) === 3 ?
										_.map(municipalities, (mun, k) => {
											let shouldCheck = _.findKey(this.props.selectedMuns, {id: mun.id}) !== undefined ? true : false;
											return (
												<div className="control" key={k}>
													<label htmlFor={`mun-${mun.id}`} className="checkbox"
													       disabled={conclusion}>
														<input id={`mun-${mun.id}`} ref={`g-mun-${mun.id}`}
														       value={mun.id} type="checkbox" checked={shouldCheck}
														       className="checkbox"
														       onChange={() => this._saveMuns(mun.id)}
														       disabled={conclusion}/>
														{mun.name}
													</label>
												</div>
											);
										})
										: this.props.muns.list.map((mun, k) => {
											let shouldCheck = _.findKey(this.props.selectedMuns, {id: mun.id}) !== undefined ? true : false;
											return (
												<div className="control" key={k}>
													<label htmlFor={`mun-${mun.id}`} className="checkbox"
													       disabled={conclusion}>
														<input id={`mun-${mun.id}`} ref={`g-mun-${mun.id}`}
														       value={mun.id} type="checkbox" checked={shouldCheck}
														       className="checkbox"
														       onChange={() => this._saveMuns(mun.id)}
														       disabled={conclusion}/>
														{mun.name}
													</label>
												</div>
											);
										})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveMuns(mun) {
		let munKey = _.findKey(this.props.selectedMuns, {id: mun});
		if (this.refs[`g-mun-${mun}`].checked) {
			this.props.add(`projects.goals[${this.props.selectedGoal}].municipalities`, {id: mun});
		} else {
			this.props.remove(`projects.goals[${this.props.selectedGoal}].municipalities`, munKey);
		}
	}
}*/

export default MunsModal;


// WEBPACK FOOTER //
// ./src/elements/projects/widgets/municipalities-modal.jsx